import { render, staticRenderFns } from "./SynchronizedProportionDiv.vue?vue&type=template&id=17cad80a&scoped=true&"
import script from "./SynchronizedProportionDiv.vue?vue&type=script&lang=js&"
export * from "./SynchronizedProportionDiv.vue?vue&type=script&lang=js&"
import style0 from "./SynchronizedProportionDiv.vue?vue&type=style&index=0&id=17cad80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cad80a",
  null
  
)

export default component.exports